import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Chip,
  Grid,
  Tooltip,
  Typography,
  TextField,
  ListItem,
  Button,
  MenuItem,
  IconButton,
  Alert,
  Snackbar,
} from "@mui/material";
import List from "@mui/material/List";
import InfoIcon from "@mui/icons-material/Info";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import paymentportalservice from "../../services/paymentportalservice";
import CloseIcon from "@mui/icons-material/Close";

function Vendor({ totalVendor }) {
  const [vendorData, setVendorData] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState("");
  const [vendors, setVendors] = useState([]);
  const [platforms, setPlatforms] = useState([]);
  const [state, setState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [viewState, setViewState] = useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  // Form state
  const [formData, setFormData] = useState({
    name: "",
    category: "",
    number: "",
  });

  const [selectedPlatform, setSelectedPlatform] = useState("");
  const [socialUrl, setSocialUrl] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Error states
  const [errors, setErrors] = useState({
    number: "",
    url: "",
  });

  // Snackbar for error messages
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });

  useEffect(() => {
    fetchVendorData();
    fetchVendorPlatforms();
    fetchVendors();
  }, []);

  async function fetchVendors() {
    try {
      const vendor = await paymentportalservice.FetchVendors();
      setVendors(vendor);
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchVendorData() {
    try {
      const response = await paymentportalservice.FetchVendorCategoriesData();
      setVendorData(response);
    } catch (error) {
      console.log("Error in fetching vendor category data");
    }
  } 

  async function fetchVendorPlatforms() {
    try {
      const response = await paymentportalservice.FetchVendorPlatforms();
      setPlatforms(response);
      console.log(response);
    } catch (error) {
      console.log("Error in fetching platforms...");
    }
  }

  function handleChangePlatforms(event) {
    setSelectedPlatform(event.target.value);
  }

  const handleClearVendor = () => {
    setSelectedVendor("");
    setFormData((prev) => ({
      ...prev,
      category: "",
    }));
  };

  const handleClearSelection = () => {
    setSelectedPlatform("");
    setSocialUrl("");
    setErrors((prev) => ({ ...prev, url: "" }));
  };

  const toggleDrawer = (anchor1, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor1]: open });
  };

  const toggleViewDrawer = (anchor2, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setViewState({ ...viewState, [anchor2]: open });
  };

  // Form handler functions
  const handleFormChange = (e) => {
    const { name, value } = e.target;

    // Validate phone number if the field is 'number'
    if (name === "number") {
      // Allow only digits and limit to 10 characters
      const phoneRegex = /^\d{0,10}$/;
      if (phoneRegex.test(value)) {
        setFormData((prev) => ({
          ...prev,
          [name]: value,
        }));
        if (value.length === 10 || value.length === 0) {
          setErrors((prev) => ({ ...prev, number: "" }));
        } else if (value.length > 0 && value.length !== 10) {
          setErrors((prev) => ({
            ...prev,
            number: "Phone number must be exactly 10 digits",
          }));
        }
      }
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const validateUrl = (url) => {
    if (!url) return true; // URL is optional
    const urlPattern =
      /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
    return urlPattern.test(url);
  };

  const handleUrlChange = (e) => {
    const url = e.target.value;
    setSocialUrl(url);

    if (url && !validateUrl(url)) {
      setErrors((prev) => ({
        ...prev,
        url: "Please enter a valid URL (e.g., https://example.com)",
      }));
    } else {
      setErrors((prev) => ({ ...prev, url: "" }));
    }
  };

  const handleVendorChange = (event) => {
    const selectedCategoryId = event.target.value;
    setSelectedVendor(selectedCategoryId);
    setFormData((prev) => ({
      ...prev,
      category: selectedCategoryId,
    }));
  };

  // Submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate required fields
    if (!formData.name) {
      setSnackbar({
        open: true,
        message: "Please enter vendor name",
        severity: "error",
      });
      return;
    }
    if (!formData.category) {
      setSnackbar({
        open: true,
        message: "Please select vendor category",
        severity: "error",
      });
      return;
    }

    // Validate phone number if provided
    if (formData.number && formData.number.length !== 10) {
      setSnackbar({
        open: true,
        message: "Phone number must be exactly 10 digits",
        severity: "error",
      });
      setErrors((prev) => ({
        ...prev,
        number: "Phone number must be exactly 10 digits",
      }));
      return;
    }

    // Validate URL if provided
    if (socialUrl && !validateUrl(socialUrl)) {
      setSnackbar({
        open: true,
        message: "Please enter a valid URL",
        severity: "error",
      });
      setErrors((prev) => ({ ...prev, url: "Please enter a valid URL" }));
      return;
    }

    // Prepare social media array
    const socialMediaArray = [];
    if (selectedPlatform && socialUrl) {
      socialMediaArray.push({
        platform: selectedPlatform,
        url: socialUrl,
      });
    }

    const vendorPayload = {
      name: formData.name,
      category: formData.category,
      number: formData.number,
      socialMedia: socialMediaArray,
    };

    setIsSubmitting(true);

    try {
      const result = await paymentportalservice.PostVendor(vendorPayload);
      console.log("Vendor added successfully:", result);

      // Reset form
      setFormData({ name: "", category: "", number: "" });
      setSelectedVendor("");
      setSelectedPlatform("");
      setSocialUrl("");
      setErrors({ number: "", url: "" });

      // Close drawer
      toggleDrawer("right", false)();

      // Refresh vendors list
      await fetchVendors();

      setSnackbar({
        open: true,
        message: "Vendor added successfully!",
        severity: "success",
      });
    } catch (error) {
      console.error("Error adding vendor:", error);
      setSnackbar({
        open: true,
        message: "Failed to add vendor. Please try again.",
        severity: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const vendorForm = (anchor1) => (
    <form onSubmit={handleSubmit}>
      <Box sx={{ paddingX: 3, paddingTop: 3 }} role="presentation">
        <Typography variant="h6" textAlign={"center"} fontWeight={"bold"}>
          Add Vendor
        </Typography>

        <List>
          <ListItem disablePadding>
            <TextField
              id="vendor-name"
              label="Vendor Name*"
              variant="outlined"
              name="name"
              value={formData.name}
              onChange={handleFormChange}
              sx={{ width: 350 }}
              required
              helperText="Enter vendor name"
            />
          </ListItem>
        </List>

        <List>
          <TextField
            select
            fullWidth
            label="Vendor Category*"
            value={selectedVendor}
            onChange={handleVendorChange}
            required
            InputProps={{
              endAdornment: selectedVendor && (
                <IconButton
                  size="small"
                  onClick={handleClearVendor}
                  onMouseDown={(e) => e.preventDefault()}
                  sx={{ mr: 1 }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              ),
            }}
          >
            {vendorData && vendorData.length > 0 ? (
              vendorData.map((item, index) => (
                <MenuItem key={index} value={item._id || item.id}>
                  {item.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No categories available</MenuItem>
            )}
          </TextField>
        </List>

        <List>
          <TextField
            select
            fullWidth
            label="Choose Platform"
            value={selectedPlatform}
            onChange={handleChangePlatforms}
            InputProps={{
              endAdornment: selectedPlatform && (
                <IconButton
                  size="small"
                  onClick={handleClearSelection}
                  onMouseDown={(e) => e.preventDefault()}
                  sx={{ mr: 1 }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              ),
            }}
          >
            {platforms && platforms.length > 0 ? (
              platforms.map((item, index) => (
                <MenuItem key={index} value={item._id || item.id}>
                  {item.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No platforms available</MenuItem>
            )}
          </TextField>

          <ListItem disablePadding sx={{ mt: 2 }}>
            <TextField
              id="vendor-number"
              label="Vendor Phone Number"
              variant="outlined"
              name="number"
              value={formData.number}
              onChange={handleFormChange}
              sx={{ width: 350 }}
              error={!!errors.number}
              helperText={errors.number || "Enter 10-digit phone number"}
              inputProps={{
                maxLength: 10,
                pattern: "[0-9]*",
              }}
            />
          </ListItem>
        </List>

        <List>
          <ListItem disablePadding>
            <TextField
              id="social-url"
              label="Social Media URL"
              variant="outlined"
              sx={{ width: 350 }}
              name="url"
              value={socialUrl}
              onChange={handleUrlChange}
              error={!!errors.url}
              helperText={errors.url || ""}
              InputProps={{
                inputProps: {
                  type: "url",
                },
              }}
            />
          </ListItem>
        </List>

        <Box sx={{ marginTop: 2, textAlign: "center", marginBottom: 3 }}>
          <Button
            variant="contained"
            type="submit"
            disabled={isSubmitting || !!errors.number || !!errors.url}
            sx={{
              color: "#000",
            }}
          >
            {isSubmitting ? "Adding..." : "Add Vendor"}
          </Button>
        </Box>
      </Box>
    </form>
  );

  const vendorView = (anchor2) => (
    <Box
      sx={{
        padding: 3,
        width: "100%",
        maxWidth: "400px",
      }}
      role="presentation"
    >
      <Typography variant="h5" sx={{ mb: 2 }}>
        Vendors ({vendors?.length || 0})
      </Typography>

      <div style={{ maxHeight: "95vh", overflowY: "auto" }}>
        {vendors && vendors.length > 0 ? (
          [...vendors].slice().map((vendor, index) => (
            <div
              key={index}
              style={{
                padding: "12px 10px",
                borderBottom: "1px solid #e0e0e0",
                backgroundColor: "#fff",
                marginBottom: "1px",
              }}
            >
              {vendor.name}
            </div>
          ))
        ) : (
          <Typography>No vendors found</Typography>
        )}
      </div>
    </Box>
  );

  const anchor1 = "right";
  const anchor2 = "right";

  return (
    <>
      <SwipeableDrawer
        anchor={anchor1}
        open={state[anchor1]}
        onClose={toggleDrawer(anchor1, false)}
        onOpen={toggleDrawer(anchor1, true)}
      >
        {vendorForm(anchor1)}
      </SwipeableDrawer>

      <SwipeableDrawer
        anchor={anchor2}
        open={viewState[anchor2]}
        onClose={toggleViewDrawer(anchor2, false)}
        onOpen={toggleViewDrawer(anchor2, true)}
      >
        {vendorView(anchor2)}
      </SwipeableDrawer>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Grid item xs={4}>
        <Card sx={{ padding: 2, borderRadius: 0, boxShadow: 0 }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <CardContent
              sx={{ padding: 1, cursor: "pointer" }}
              onClick={toggleViewDrawer(anchor2, true)}
            >
              <Typography component="div" variant="h5">
                <Chip
                  label={totalVendor}
                  size="small"
                  variant="filled"
                  sx={{ backgroundColor: "#F9B572", color: "#ffffff" }}
                />
              </Typography>
              <Typography
                variant="subtitle1"
                color="text.secondary"
                component="div"
                fontWeight={"bold"}
              >
                VENDORS
              </Typography>
            </CardContent>
            <Box sx={{ alignSelf: "center" }}>
              <Tooltip title="Add Vendor" onClick={toggleDrawer(anchor1, true)}>
                <AddCircleIcon sx={{ cursor: "pointer", color: "#FFD206" }} />
              </Tooltip>
              <Tooltip
                title="View Vendors"
                onClick={toggleViewDrawer(anchor2, true)}
              >
                <InfoIcon sx={{ cursor: "pointer", color: "#0AC380" }} />
              </Tooltip>
            </Box>
          </Box>
        </Card>
      </Grid>
    </>
  );
}

export default Vendor;
